<form [formGroup]="registeredUserForm">

  <div class="form-group row">
    <label class="col-3 col-form-label"
      >First Name <span class="astric">*</span></label
      >
      <kendo-textbox
        class="col-9"
        placeholder="FirstName"
        name="firstName"
        [(ngModel)]="firstName"
        formControlName="firstName"
        required
        >
      </kendo-textbox>
      @if (registeredUserForm.touched && registeredUserForm.controls.firstName.errors?.required) {
        <app-error-message message="First Name is required"  [isError]="true"></app-error-message>
      }

      @if (!registeredUserForm?.controls?.firstName?.errors?.required && registeredUserForm?.controls?.firstName?.errors?.maxlength) {
        <app-error-message message="Max length is 128 chars"
        [isError]="true"></app-error-message>
      }
      @if (!registeredUserForm?.controls?.firstName?.errors?.required && registeredUserForm?.controls?.firstName?.errors?.minlength) {
        <app-error-message message="Min length is 1 char"
        [isError]="true"></app-error-message>
      }
      @if (!registeredUserForm?.controls?.firstName?.errors?.required && registeredUserForm?.controls?.firstName?.errors?.cannotContainSpaceOnly) {
        <app-error-message message="First Name can't contain space only"
        [isError]="true"></app-error-message>
      }
      @if (!registeredUserForm?.controls?.firstName?.errors?.required && registeredUserForm?.controls?.firstName?.errors?.cannotStartWithWhiteSpace) {
        <app-error-message message="First Name can't start with white space"
        [isError]="true"></app-error-message>
      }
      @if (!registeredUserForm?.controls?.firstName?.errors?.required && registeredUserForm?.controls?.firstName?.errors?.cannotEndWithWhiteSpace) {
        <app-error-message message="First Name can't end with white space"
        [isError]="true"></app-error-message>
      }
      @if (!registeredUserForm?.controls?.firstName?.errors?.required && registeredUserForm?.controls?.firstName?.errors?.cannotBeNumbersOnly) {
        <app-error-message message="First Name can't be numbers only"
        [isError]="true"></app-error-message>
      }
      @if (!registeredUserForm?.controls?.firstName?.errors?.required && registeredUserForm?.controls?.firstName?.errors?.cannotBeSpecialCharsOnly) {
        <app-error-message message="First Name can't be special chars only"
        [isError]="true"></app-error-message>
      }
    </div>
    <div class="form-group row">
      <label class="col-3 col-form-label"
        >Last Name <span class="astric">*</span></label
        >
        <kendo-textbox
          class="col-9"
          placeholder="LastName"
          name="lastName"
          [(ngModel)]="lastName"
          formControlName="lastName"
          required
          >
        </kendo-textbox>
        @if (registeredUserForm.touched && registeredUserForm.controls.firstName.errors?.required) {
          <app-error-message message="Last Name is required"  [isError]="true"></app-error-message>
        }

        @if (!registeredUserForm?.controls?.lastName?.errors?.required && registeredUserForm?.controls?.lastName?.errors?.maxlength) {
          <app-error-message message="Max length is 128 chars"
          [isError]="true"></app-error-message>
        }
        @if (!registeredUserForm?.controls?.lastName?.errors?.required && registeredUserForm?.controls?.lastName?.errors?.minlength) {
          <app-error-message message="Min length is 1 char"
          [isError]="true"></app-error-message>
        }
        @if (!registeredUserForm?.controls?.lastName?.errors?.required && registeredUserForm?.controls?.lastName?.errors?.cannotContainSpaceOnly) {
          <app-error-message message="Last Name can't contain space only"
          [isError]="true"></app-error-message>
        }
        @if (!registeredUserForm?.controls?.lastName?.errors?.required && registeredUserForm?.controls?.lastName?.errors?.cannotStartWithWhiteSpace) {
          <app-error-message message="Last Name can't start with white space"
          [isError]="true"></app-error-message>
        }
        @if (!registeredUserForm?.controls?.lastName?.errors?.required && registeredUserForm?.controls?.lastName?.errors?.cannotEndWithWhiteSpace) {
          <app-error-message message="Last Name can't end with white space"
          [isError]="true"></app-error-message>
        }
        @if (!registeredUserForm?.controls?.lastName?.errors?.required && registeredUserForm?.controls?.lastName?.errors?.cannotBeNumbersOnly) {
          <app-error-message message="Last Name can't be numbers only"
          [isError]="true"></app-error-message>
        }
        @if (!registeredUserForm?.controls?.lastName?.errors?.required && registeredUserForm?.controls?.lastName?.errors?.cannotBeSpecialCharsOnly) {
          <app-error-message message="Last Name can't be special chars only"
          [isError]="true"></app-error-message>
        }
      </div>
      <div class="form-group row">
        <label class="col-3 col-form-label"
          >ُEmail <span class="astric">*</span></label
          >
          <kendo-textbox
            class="col-9"
            placeholder="Email"
            name="email"
            [(ngModel)]="email"
            formControlName="email"
            required
            >
          </kendo-textbox>
          <app-error-message
            [message]="emailError"
            [isError]="true"
          ></app-error-message>
        </div>

        <div class="form-group row">
          <label class="col-3 col-form-label"
            >Phone <span class="astric">*</span></label
            >
            <kendo-textbox
              class="col-9"
              placeholder="Phone"
              name="phone"
              [(ngModel)]="phone"
              formControlName="phone"

              required
              >
            </kendo-textbox>
            <label class="col-3 col-form-label"></label>
            <!-- <label for="phone" class="col-9 col-form-label">the phone pattern is '+000 - 0000000000'</label> -->
            <app-error-message
              [message]="phoneError"
              [isError]="true"
            ></app-error-message>
          </div>
          <div class="form-group row">
            <label class="col-3 col-form-label"
              >Region <span class="astric">*</span></label
              >
              <kendo-textbox
                class="col-9"
                placeholder="Region"
                name="region"
                [(ngModel)]="region"
                formControlName="region"
                required
                >
              </kendo-textbox>
              @if (registeredUserForm.touched && registeredUserForm.controls.firstName.errors?.required) {
                <app-error-message message="Region is required"  [isError]="true"></app-error-message>
              }
              @if (!registeredUserForm?.controls?.region?.errors?.required && registeredUserForm?.controls?.region?.errors?.maxlength) {
                <app-error-message message="Max length is 128 chars"
                [isError]="true"></app-error-message>
              }
              @if (!registeredUserForm?.controls?.region?.errors?.required && registeredUserForm?.controls?.region?.errors?.minlength) {
                <app-error-message message="Min length is 1 char"
                [isError]="true"></app-error-message>
              }
              @if (!registeredUserForm?.controls?.region?.errors?.required && registeredUserForm?.controls?.region?.errors?.cannotContainSpaceOnly) {
                <app-error-message message="Region Name can't contain space only"
                [isError]="true"></app-error-message>
              }
              @if (!registeredUserForm?.controls?.region?.errors?.required && registeredUserForm?.controls?.region?.errors?.cannotStartWithWhiteSpace) {
                <app-error-message message="Region Name can't start with white space"
                [isError]="true"></app-error-message>
              }
              @if (!registeredUserForm?.controls?.region?.errors?.required && registeredUserForm?.controls?.region?.errors?.cannotEndWithWhiteSpace) {
                <app-error-message message="Region Name can't end with white space"
                [isError]="true"></app-error-message>
              }
              @if (!registeredUserForm?.controls?.region?.errors?.required && registeredUserForm?.controls?.region?.errors?.cannotBeNumbersOnly) {
                <app-error-message message="Region Name can't be numbers only"
                [isError]="true"></app-error-message>
              }
              @if (!registeredUserForm?.controls?.region?.errors?.required && registeredUserForm?.controls?.region?.errors?.cannotBeSpecialCharsOnly) {
                <app-error-message message="Region Name can't be special chars only"
                [isError]="true"></app-error-message>
              }
            </div>
            <div class="form-group row">
              <label class="col-3 col-form-label"
                >Title <span class="astric">*</span></label
                >
                <kendo-textbox
                  class="col-9"
                  placeholder="Title"
                  name="title"
                  [(ngModel)]="title"
                  formControlName="title"
                  required
                  >
                </kendo-textbox>
                @if (registeredUserForm.touched && registeredUserForm.controls.firstName.errors?.required) {
                  <app-error-message message="Title is required"  [isError]="true"></app-error-message>
                }
                @if (!registeredUserForm?.controls?.title?.errors?.required && registeredUserForm?.controls?.title?.errors?.maxlength) {
                  <app-error-message message="Max length is 128 chars"
                  [isError]="true"></app-error-message>
                }
                @if (!registeredUserForm?.controls?.title?.errors?.required && registeredUserForm?.controls?.title?.errors?.minlength) {
                  <app-error-message message="Min length is 1 char"
                  [isError]="true"></app-error-message>
                }
                @if (!registeredUserForm?.controls?.title?.errors?.required && registeredUserForm?.controls?.title?.errors?.cannotContainSpaceOnly) {
                  <app-error-message message="Title can't contain space only"
                  [isError]="true"></app-error-message>
                }
                @if (!registeredUserForm?.controls?.title?.errors?.required && registeredUserForm?.controls?.title?.errors?.cannotStartWithWhiteSpace) {
                  <app-error-message message="Title can't start with white space"
                  [isError]="true"></app-error-message>
                }
                @if (!registeredUserForm?.controls?.title?.errors?.required && registeredUserForm?.controls?.title?.errors?.cannotEndWithWhiteSpace) {
                  <app-error-message message="Title can't end with white space"
                  [isError]="true"></app-error-message>
                }
                @if (!registeredUserForm?.controls?.title?.errors?.required && registeredUserForm?.controls?.title?.errors?.cannotBeNumbersOnly) {
                  <app-error-message message="Title can't be numbers only"
                  [isError]="true"></app-error-message>
                }
                @if (!registeredUserForm?.controls?.title?.errors?.required && registeredUserForm?.controls?.title?.errors?.cannotBeSpecialCharsOnly) {
                  <app-error-message message="Title can't be special chars only"
                  [isError]="true"></app-error-message>
                }
              </div>

              <div class="form-group row">
                <label class="col-3 col-form-label"
                  >Company Type<span class="astric">*</span></label
                  >
                  <app-dropdown-list
                    class="col-9"
                    [data]="CompanyTypes"
                    textField="companyTypeName"
                    valueField="companyTypeId"
                    [valuePrimitive]="true"
                    (selectionChange)="getSelectedCompanyTypeItem($event)"
                    [selectedItem]="companyId"
                    >
                  </app-dropdown-list>
                  <app-error-message
                    [message]="companyTypeError"
                    [isError]="true"
                  ></app-error-message>
                </div>
                <div class="form-group row">
                  <label class="col-3 col-form-label"
                    >Company <span class="astric">*</span></label
                    >
                    <kendo-dropdownlist  defaultItem="Select Value"  class="col-9"  [filterable]="true" [data]="CompanyList" textField="name" valueField="id"
                      formControlName="companyName"  (selectionChange)="companyChange($event)" (filterChange)="click($event)">
                    </kendo-dropdownlist>
                    <app-error-message
                      [message]="companyError"
                      [isError]="true"
                    ></app-error-message>
                  </div>
                  <div class="form-group row">
                    <label class="col-3 col-form-label">CM Site<span class="astric">*</span></label>
                    <kendo-dropdownlist  [disabled]="CmSiteDisabled" [defaultItem]="defaultcmSite"  class="col-9"  [filterable]="true" [data]="cmSiteListItems" textField="cmSiteName" valueField="cmSiteId"
                      formControlName="cmSite" (filterChange)="handleFilterCMsite($event)">
                    </kendo-dropdownlist>
                    <app-error-message [message]="cmSiteError" [isError]="true"></app-error-message>
                  </div>

                  <div class="form-group row">
                    <label class="col-3 col-form-label">Role<span class="astric">*</span></label>
                    <app-dropdown-list
                      class="col-9"
                      [data]="RolelistItems"
                      textField="roleName"
                      valueField="roleId"
                      [valuePrimitive]="true"
                      (selectionChange)="getSelectedRole($event)"
                      [selectedItem]="role"
                      >
                    </app-dropdown-list>
                    <app-error-message [message]="roleError" [isError]="true"></app-error-message>
                  </div>
                  <div class="form-group row">
                    <label class="col-3 col-form-label"
                      >Login Status<span class="astric">*</span></label
                      >
                      <!-- <input type="radio" name="name" [(ngModel)]="loginStatus" value="Enabled"
                      kendoRadioButton />
                      Enabled

                      <input type="radio" name="name"  [(ngModel)]="loginStatus" value="Disabled"
                        kendoRadioButton />
                        Disabled -->
                        <app-check-box
                          [text]="'Enabled'"
                          [value]="checkedEnabledvalue"
                          [name]="'loginStatus'"
                          (change)="getCheckedValue($event)"
                          [checkedStatus]="checkedStatusEnable"
                        ></app-check-box>

                        <app-check-box
                          [checkedStatus]="checkedStatusDisable"
                          [text]="'Disabled'"
                          [value]="checkedDisabledvalue"
                          [name]="'loginStatus'"
                          (change)="getCheckedValue($event)"

                        ></app-check-box>


                      </div>
                      @if (this.IsError) {
                        <app-error-message
                          message="{{ error }}"
                          [isError]="true"
                        ></app-error-message>
                      }
                    </form>